// Bundled Gemini 4 translations for market-specific product content. No customer data.
import ptBR from "./markets/pt-BR.json";
import tr from "./markets/tr.json";
import vi from "./markets/vi.json";
import id from "./markets/id.json";
import ukComments from "./markets/uk-comments.json";
export const MARKET_LOCALES = ["pt-BR", "tr", "vi", "id"] as const;
export type MarketLocale = typeof MARKET_LOCALES[number];
export const isMarketLocale = (locale: string): locale is MarketLocale => (MARKET_LOCALES as readonly string[]).includes(locale);
export const MARKET_CONTENT = { "pt-BR": ptBR, tr, vi, id };

// "id" is an existing sentence-bank item identifier property, so its output-language tag uses the full locale.
// "uk" (D-236) is a light language: it has a comment bank but no market data (grades, starters, demo class).
export const MARKET_COMMENT_LANGS = ["pt-BR", "tr", "vi", "id-ID", "uk"] as const;
export type MarketCommentLang = typeof MARKET_COMMENT_LANGS[number];
export const isMarketCommentLang = (lang: string): lang is MarketCommentLang => (MARKET_COMMENT_LANGS as readonly string[]).includes(lang);
const COMMENT_BANKS = { "pt-BR": ptBR.comments, tr: tr.comments, vi: vi.comments, "id-ID": id.comments, uk: ukComments };
export const marketComments = (lang: MarketCommentLang) => COMMENT_BANKS[lang];
